import {useEffect, useMemo} from 'react'
import {useHistory, useLocation} from 'react-router-dom'

export const usePaginationUrlParams = () => {
    const history = useHistory()
    const location = useLocation()

    const displayedPage = useMemo(() => {
        const searchParams = new URLSearchParams(location.search)
        const currentDisplayedPage = isNaN(Number(searchParams.get('page')))
            ? searchParams.get('page')
            : Number(searchParams.get('page'))
        return currentDisplayedPage
    }, [location])

    const updatePageParam = (queryValue) => {
        const searchParams = new URLSearchParams(location.search)
        searchParams.set('page', queryValue)
        history.push(`${location.pathname}?${searchParams.toString()}`)
    }

    const showNextPage = () => {
        const nextPage = displayedPage + 1
        updatePageParam(nextPage)
    }

    const getAllEntries = () => {
        updatePageParam('all')
    }

    const showAll = useMemo(() => displayedPage === 'all', [displayedPage])

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search)
        if (!searchParams.has('page')) {
            searchParams.set('page', '1')
            history.replace(`${location.pathname}?${searchParams.toString()}`)
        }
    }, [location.search, location.pathname, history])

    useEffect(() => {
        const unlisten = history.listen(() => {
            sessionStorage.setItem('scrollPosition', window.scrollY)
        })

        return () => unlisten()
    }, [history])

    useEffect(() => {
        const savedPosition = sessionStorage.getItem('scrollPosition')
        if (!savedPosition) return

        const scrollPos = parseInt(savedPosition, 10)
        setTimeout(() => {
            const maxScrollHeight = document.documentElement.scrollHeight - window.innerHeight

            if (scrollPos > maxScrollHeight) {
                window.scrollTo(0, 0)
            } else {
                window.scrollTo(0, scrollPos)
            }
        }, 100)
    }, [])

    return {
        showNextEntries: showNextPage,
        showAll,
        getAllEntries,
        displayedPage
    }
}
